<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_v"></a><a id="author"><strong>Author’s Note</strong></a></h2><a id="author">
<p class="indent">Navaho healing ceremonials, commonly known as “sings,” are properly called “Ways,” because of the precise manner in which they must be conducted. In these ceremonies, or ways, myth-dramas are acted out.</p>
<p class="indent">One of the more popular rites is Night Way. In it, Changing Woman (comparable to Mother Nature), who gave birth to the Navaho race, tried to create light in a world of darkness. On the floor of the hogan, she made a dry-painting: white first for dawn; on it, blue for morning; on the blue, yellow for sunset; and, finally, black for night on the yellow. She prayed but no light came.</p>
<p class="indent">She added turquoise and white shell beads. After her prayers, a faint light appeared. The twelve Holy People came to help, bringing more turquoise and shell beads to make a magic circle. Changing Woman held a crystal above it. A bright blaze appeared, but it was so hot and bright, they had to keep raising it and moving it to keep it at a safe distance.</p>
<p class="indent">In this way, light was created.</p>
</a><p class="indent"><a id="author">There are some 570 “songs” in Night Way. The verses quoted from selected “songs,” beginning each part of this book, are from translations by Washington Matthews, a noted authority on the Navahos.</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?50ff6636